<script>
import { size } from 'lodash'
import { mapGetters } from 'vuex'

import InventoryItemTypeCell from '@/components/widgets/InventoryItemTypeCell'

const slotCount = 8

export default {
  name: 'ViewInventory',

  components: {
    InventoryItemTypeCell
  },

  computed: {

    ...mapGetters([
      'inventoryItemsByType'
    ]),

    blankCellCount () {
      return slotCount - size(this.inventoryItemsByType)
    }

  }
}
</script>

<template>
  <div class="c-view-inventory">
    <div class="c-view-inventory-content">

      <div class="c-view-inventory-grid">

        <!-- Inventory items -->
        <div
          v-for="(inventoryItems, type) in inventoryItemsByType"
          :key="type"
          class="c-view-inventory-cell"
        >
          <inventory-item-type-cell
            :inventory-items="inventoryItems"
          />
        </div>

        <!-- Blank cells -->
        <template v-if="blankCellCount">

          <div
            v-for="i in blankCellCount"
            :key="i"
            class="c-view-inventory-cell-blank"
          />

        </template>

      </div>

    </div>
  </div>
</template>

<style lang="scss">

.c-view-inventory-content {
  @include keep-center;
  @include limit-content-loose;
}

.c-view-inventory-grid {
  @include grid;
  @include grid-columns(4);
  @include grid-gap($pad-horizontal, $pad-horizontal);
}

.c-view-inventory-cell,
.c-view-inventory-cell-blank {
  @include relative;
  background-color: $very-dark;
}

.c-view-inventory-cell-blank {
  @include pad-loose;
  min-height: 4rem;
  background-color: $very-dark;
}

.c-view-inventory-image {
  @include large-font;
}

// .c-view-inventory-title {}

// .c-view-inventory-module {}

</style>
